import React, { useEffect, useRef, useState } from "react";
import "../../On_going/Published_Assessment/PublishedHomeworkActivity.css";
import { Link, useNavigate } from "react-router-dom";
import PublishAssessBoxActivity from "../Published/published_access_box/PublishAssessBoxActivity";
import DraftAssessBoxActivity from "../Draft/Draft_Assess_Box/DraftAssessBoxActivity";
import ScheduleAssessBoxActivity from "../../SChedule/Schedule_Assess_box/ScheduleAssessBoxActivity";
import SubjectBox from "./Published_Subj_Box/SubjectBox";
import ReviewAssessBoxActivity from "../../onreview/OnReview_Assessment_Box/ReviewAssessBoxActivity";
import CompletedAssessBoxActivity from "../../Completed/Completed_Assessment_Box/CompletedAssessBoxActivity";
import { Popup } from "semantic-ui-react";
//import FilterBox from "../../../Pre-read/On_going_PreRead/Published_Assessment_PreRead/Filter_Box/FilterBox";
import FilterBox from "../../../pages/On_going/Published_Assessment/Filter_Box/FilterBox";
import ImagePopupBox from "../../../../DCM/components/PopUp/ImagePopup/ImagePopupBox";
import ActivityImage from "./../../../../images/Activity_Process_Flow.png";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
  Button,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Alert } from "@mui/material";
// localStorage.setItem("buttons", "Published");

const PublishedHomeworkActivity = ({ leftSidebarSize }) => {
  let general_role = localStorage.getItem("general_role");
  let generalRole_JSON = JSON.parse(general_role);

  let classTeacher = localStorage.getItem("role_as_class_teacher");
  let classTeacher_JSON = JSON.parse(classTeacher);

  let cordinator = localStorage.getItem("role_as_co_ordinator");
  let cordinator_JSON = JSON.parse(cordinator);
  const [openImg, setOpenImg] = useState(false);
  const [activeHeader, setActiveHeader] = useState(
    localStorage.getItem("mainButtons"),
  );
  const [openUnsavedDialog, setOpenUnsavedDialog] = useState(false);

  const mainButtons = localStorage.getItem("mainButtons");
  const [activeSubHeader, setActiveSubHeader] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem("mainButtons") === "Created") {
      localStorage.setItem("buttons", "Published");
    } else {
      localStorage.removeItem("buttons");
    }
    setActiveSubHeader(localStorage.getItem("buttons"));
  }, []);
  const buttons = localStorage.getItem("buttons");

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const popupRef = useRef(null);

  // useClickOutside(popupRef, () => setIsPopupOpen(false));
  //Here I added logic for toggle filter box

  // useEffect(() => {
  //   const handleOutsideClick = (event) => {
  //     console.log(popupRef.current.contains(event.target));
  //     if (popupRef.current && !popupRef?.current?.contains(event.target)) {
  //       setIsPopupOpen(false);
  //     }
  //   };
  //   if (isPopupOpen) {
  //     document.addEventListener("click", handleOutsideClick);
  //   }
  //   return () => {
  //     document.removeEventListener("click", handleOutsideClick);
  //   };
  // }, [isPopupOpen]);

  const handlePopupClick = (event) => {
    event.stopPropagation();
    setIsPopupOpen(!isPopupOpen);
  };

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const [filter, setFilter] = useState({
    subjectId: [],
    date: "",
    time: "",
    searchvalue: "",
    standard_id: "",
    section_id: "",
  });
  let sectionArr = [];
  let standardArr = [];

  const dropDownHelper = () => {
    function addUniqueObjectToArraystand(obj) {
      if (
        !standardArr.some(
          (item) => JSON.stringify(item) === JSON.stringify(obj),
        )
      ) {
        standardArr.push(obj);
      }
    }
    generalRole_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    classTeacher_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    cordinator_JSON?.map((obj) => addUniqueObjectToArraystand(obj.standard_id));
  };

  dropDownHelper();
  const handleDropDownSec = () => {
    function addUniqueObjectToArraysect(obj) {
      if (
        !sectionArr.some((item) => JSON.stringify(item) === JSON.stringify(obj))
      ) {
        sectionArr.push(obj);
      }
    }

    generalRole_JSON?.map((obj) => {
      // if (obj?.standard_id?.id === filter?.standard_id) {
      addUniqueObjectToArraysect(obj.section_id);
      // }
    });
    classTeacher_JSON?.map((obj) => {
      // if (obj?.standard_id?.id === filter?.standard_id) {
      addUniqueObjectToArraysect(obj.section_id);
      // }
    });
    cordinator_JSON?.map((obj) => {
      // if (obj?.standard_id?.id === filter?.standard_id) {
      addUniqueObjectToArraysect(obj.section_id);
      // }
    });
  };
  handleDropDownSec();

  const SavedActivityData = JSON.parse(
    localStorage.getItem("ActivityLocalStorageData"),
  );

  const checkLocalData = () => {
    if (SavedActivityData) {
      setOpenUnsavedDialog(true);
    } else {
      navigate("/CreateActivity");
    }
  };

  const handleContinueSaved = () => {
    setOpenUnsavedDialog(false);
    if (SavedActivityData) {
      navigate("/CreateActivity");
    }
  };

  const handleCreateNew = () => {
    localStorage.removeItem("ActivityLocalStorageData");
    setOpenUnsavedDialog(false);
    navigate("/CreateActivity");
  };

  return (
    <>
      <div className="h-100" style={{ position: "relative" }}>
        {/* Header Section */}
        <div
          className="d-flex justify-content-between align-items-center flex-wrap gap-3"
          style={{
            background: "#fff",
            borderRadius: "14px",
            padding: "4px 8px",
          }}
        >
          {/* Left Content */}
          <div>
            <h3
              style={{
                fontSize: "22px",
                fontWeight: 500,
                marginBottom: "4px",
                color: "#222",
              }}
            >
              Subject-wise Activity
            </h3>

            <p
              style={{
                margin: 0,
                fontSize: "15px",
                color: "#666",
                fontWeight: 200,
              }}
            >
              Explore, Experiment & Excel with Activities Across Subjects
            </p>
          </div>

          {/* Right Image */}
          <div>
            <img
              src="/ActivityIcons/activityLogo.jpeg"
              alt="activity"
              style={{
                height: "60px",
                objectFit: "contain",
              }}
            />
          </div>
        </div>

        {/* Subject Box */}
        <div className={`${leftSidebarSize === 70 ? "expand" : "collapasess"}`}>
          <SubjectBox filter={filter} />
        </div>

        <div className=" me-3 main_button_box">
          <div className="col-md-4 p-0 m-0  d-flex align-items-center justify-content-between main_button_box1">
            <button
              className={`  poppins-semibold  ${
                // activeHeader === "Created"
                mainButtons === "Created"
                  ? "active main_three_button_active orange-text poppins-semibold "
                  : "main_three_button "
              }`}
              onClick={(e) => {
                setActiveSubHeader("Published");
                setActiveHeader("Created");
                localStorage.setItem("buttons", "Published");
                // setFilter({
                //   ...filter,
                //   subjectId: [],
                //   date: "",
                //   time: "",
                // });
                localStorage.setItem("mainButtons", "Created");
                localStorage.setItem("buttons", "Published");
              }}
            >
              Pending
            </button>
            <button
              className={`  poppins-semibold  ${
                // activeHeader === "Review"
                mainButtons === "Review"
                  ? "active main_three_button_active orange-text poppins-semibold "
                  : "main_three_button "
              }`}
              onClick={(e) => {
                setActiveHeader("Review");
                localStorage.setItem("buttons", "");

                setActiveSubHeader("");

                localStorage.removeItem("buttons");

                // clearStateVariable();
                window.addEventListener("beforeunload", function () {
                  localStorage.removeItem("buttons");
                });

                // setFilter({
                //   ...filter,
                //   subjectId: [],
                //   date: "",
                //   time: "",
                // });

                localStorage.setItem("mainButtons", "Review");
                localStorage.setItem("buttons", "");
              }}
            >
              On Review
            </button>
            <button
              className={`  poppins-semibold  ${
                // activeHeader === "Completed"
                mainButtons === "Completed"
                  ? "active main_three_button_active orange-text poppins-semibold "
                  : "main_three_button "
              }`}
              onClick={(e) => {
                setActiveHeader("Completed");
                localStorage.setItem("buttons", "");

                setActiveSubHeader("");

                localStorage.removeItem("buttons");

                // setFilter({
                //   ...filter,
                //   subjectId: [],
                //   date: "",
                //   time: "",
                // });
                localStorage.setItem("mainButtons", "Completed");
              }}
            >
              Completed
            </button>
          </div>

          <div className="col-xl-6 col-lg-5 col-md-7 p-0 d-flex align-items-center justify-content-between tablet-layout">
            {/* <div className=" published_search_box_Activity"> */}
            <div className=" col-12 col-md-6 p-0 tab-margin">
              <input
                className="form-control mr-sm-2 m-0 name_search_box"
                type="search"
                placeholder=" Search By Activity Name"
                aria-label="Search"
                onChange={(e) => {
                  setFilter({
                    ...filter,
                    searchvalue: e.target.value,
                  });
                }}
              ></input>
              <img
                className="name_search_icon"
                src="/images/search icon.svg"
                alt=""
              />
            </div>
            {/* djkdkj */}
            {/* <div className="  d-flex gap-2  "> */}
            <Popup
              on="click"
              className="popup_filter_box"
              style={{ zIndex: "999" }}
              open={isPopupOpen}
              onOpen={togglePopup}
              onClose={togglePopup}
              trigger={
                <div
                  className="col-md-2 col-12 gap-2  filter_button tab-margin"
                  onClick={handlePopupClick}
                >
                  <img
                    src="/images/filter_icon.svg"
                    alt=""
                    onClick={handlePopupClick}
                  />
                  <span>Filter</span>
                </div>
              }
              content={
                <div ref={popupRef}>
                  <FilterBox
                    setFilter={setFilter}
                    filter={filter}
                    setIsPopupOpen={setIsPopupOpen}
                    togglePopup={togglePopup}
                  />
                </div>
              }
              position="bottom center"
            />

            <div
              className=" gap-2 col-md-3 col-12  published_add_assessment_activity tab-margin"
              onClick={() => {
                checkLocalData();
                localStorage.setItem("ActiveBtn", "");
              }}
            >
              <img className="filter_icon" src="/images/add icon.svg" alt="" />
              <span>Add Activity</span>
            </div>

            {/* </div> */}
          </div>
        </div>

        <div
          className=" my-2 me-3 parent_published_draft1"
          style={{ position: "relative" }}
        >
          <div className="col-lg-3 col-md-4 col-12 m-0 p-0  published_schedule_draft1  ">
            {activeHeader === "Created" && (
              <>
                <button
                  className={` ${
                    //activeSubHeader === "Published"
                    buttons === "Published"
                      ? "active sub_main_three_button_active mx-2"
                      : "sub_main_three_button mx-2"
                  }`}
                  onClick={(e) => {
                    setActiveSubHeader("Published");
                    setFilter({
                      ...filter,
                      subjectId: [],
                      date: "",
                      time: "",
                    });
                    localStorage.setItem("buttons", "Published");
                  }}
                >
                  Published
                </button>
                <button
                  className={` ${
                    // activeSubHeader === "Draft"
                    buttons === "Draft"
                      ? "active sub_main_three_button_active mx-2"
                      : "sub_main_three_button mx-2"
                  }`}
                  onClick={(e) => {
                    setActiveSubHeader("Draft");
                    // setFilter({
                    //   ...filter,
                    //   subjectId: [],
                    //   date: "",
                    //   time: "",
                    // });
                    localStorage.setItem("buttons", "Draft");
                  }}
                >
                  Draft
                </button>
                {/* <button
                  className={` ${
                    // activeSubHeader === "Scheduled"
                    buttons === "Scheduled"
                      ? "active pub_sch_dra_active_btn mx-2"
                      : "pub_sch_dra_btn mx-2"
                  }`}
                  onClick={(e) => {
                    setActiveSubHeader("Scheduled");
                    setFilter({
                      ...filter,
                      subjectId: [],
                      date: "",
                      time: "",
                    });
                    localStorage.setItem("buttons", "Scheduled");
                  }}
                >
                  Scheduled
                </button> */}
              </>
            )}
          </div>
          <Alert
            icon={<InfoOutlinedIcon fontSize="small" />}
            severity="info"
            onClick={() => setOpenImg(true)}
            sx={{
              fontSize: "0.8rem",
              cursor: "pointer",
              width: "fit-content",
              padding: "4px 8px",
              "&:hover": {
                backgroundColor: "#e3f2fd", // hover effect
              },
            }}
          >
            Click to Know Details
          </Alert>
          <div className="m-0 mt-1 p-0 col-6 gap-2 col-md-4 d-flex align-items-center ">
            {/* Class Select */}
            <FormControl size="small" fullWidth sx={{ minWidth: 150 }}>
              <InputLabel>Select Class</InputLabel>
              <Select
                label="Select Class"
                value={filter.standard_id}
                onChange={(e) =>
                  setFilter({
                    ...filter,
                    standard_id: e.target.value,
                    section_id: "",
                  })
                }
              >
                <MenuItem value="">Select Class</MenuItem>
                {standardArr?.length > 0 &&
                  [...standardArr]
                    .sort((a, b) => {
                      const aNum = Number(a.name);
                      const bNum = Number(b.name);

                      const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                      if (bothNumeric) {
                        return aNum - bNum; // numeric sort
                      }

                      return a.name.localeCompare(b.name); // alphabetical sort
                    })
                    .map((standard, index) => (
                      <MenuItem
                        key={index}
                        value={standard?.id}
                        name={standard?.name}
                      >
                        {standard?.name}
                      </MenuItem>
                    ))}
              </Select>
            </FormControl>

            {/* Section Select */}
            <FormControl size="small" fullWidth sx={{ minWidth: 150, ml: 2 }}>
              <InputLabel>Select Section</InputLabel>
              <Select
                label="Select Section"
                value={filter.section_id}
                onChange={(e) =>
                  setFilter({
                    ...filter,
                    section_id: e.target.value,
                  })
                }
                disabled={!filter.standard_id} // Class select hone se pehle disable
              >
                <MenuItem value="">Select Section</MenuItem>
                {sectionArr &&
                  sectionArr.length > 0 &&
                  sectionArr
                    .slice()
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((obj) => (
                      <MenuItem key={obj.id} value={obj.id}>
                        {obj.name}
                      </MenuItem>
                    ))}
              </Select>
            </FormControl>
          </div>
        </div>

        <div className="me-3 published_activity_conatainer">
          <div
            className="d-flex flex-wrap box_gap_activity orange-scrollBar w-100"
            style={{
              height: "280px",
              overflowY: "scroll",
              paddingTop: "1em",
              paddingBottom: "1em",
            }}
          >
            {activeSubHeader === "Published" && (
              <PublishAssessBoxActivity filter={filter} />
            )}
            {/* {activeSubHeader === "Scheduled" && (
              <ScheduleAssessBoxActivity filter={filter} />
            )} */}
            {activeHeader === "Review" && (
              <ReviewAssessBoxActivity filter={filter} />
            )}
            {activeHeader === "Completed" && (
              <CompletedAssessBoxActivity filter={filter} />
            )}
            {activeSubHeader === "Draft" && (
              <DraftAssessBoxActivity filter={filter} />
            )}
          </div>

          {openImg && (
            <ImagePopupBox setOpenImg={setOpenImg} imgSrc={ActivityImage} />
          )}
        </div>

        <Dialog
          open={openUnsavedDialog}
          onClose={() => setOpenUnsavedDialog(false)}
        >
          <DialogTitle>Unsaved Changes Found</DialogTitle>
          <DialogContent>
            <Typography>
              You already have an unsaved Activity –{" "}
              <Typography
                component="span"
                sx={{
                  fontWeight: "bold",
                  color: "error.main",
                  textDecoration: "underline",
                }}
              >
                {SavedActivityData?.tittle}
              </Typography>
              . Do you want to continue with it or start a new one?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setOpenUnsavedDialog(false)}
              color="primary"
              variant="contained"
            >
              Cancel
            </Button>
            <Button
              onClick={handleContinueSaved}
              color="primary"
              variant="outlined"
            >
              Continue Saved
            </Button>
            <Button onClick={handleCreateNew} color="error" variant="contained">
              Create New
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default PublishedHomeworkActivity;
